exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-tabs{display:block}adp-tabs .tabs-nav{position:relative;background-color:#fff}adp-tabs .tabs-nav.border{border-bottom:1px solid #e4e4e4}adp-tabs ul{position:relative;display:flex;flex-direction:row;align-items:center;font-family:ProximaNova-Semibold,Arial,Helvetica,sans-serif;font-size:14px}adp-tabs ul li a{display:inline-block;padding:10px 19px;color:#4a4a4a;line-height:1;transition:color .3s ease}adp-tabs ul li a.current{color:#0e5061;transition:color .3s ease}adp-tabs .indicator{position:absolute;bottom:0;left:0;height:0;width:0;border-bottom:2px solid #086274;transition:width .4s ease-in-out,transform .4s ease-in-out}adp-tabs .indicator.no-transition{transition:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpTabs/adpTabs.less
// module id = 504
// module chunks = 0